/* F1B.3C locale-aware, read-only Shopify identity boundary. Never initialized automatically. */
(function(root,factory){
  'use strict';
  if(typeof module==='object'&&module.exports)module.exports=factory(require('./nikuya-cart-managed-ownership.js'));
  else if(!root.NikuyaCartRuntimeIdentity)root.NikuyaCartRuntimeIdentity=factory(root.NikuyaCartManagedOwnership);
})(typeof globalThis!=='undefined'?globalThis:this,function(Ownership){
  'use strict';
  const privateKeys=['_nikuya_reward','_nikuya_hero_sku','_nikuya_case_sku','_nikuya_acq_revision','_nikuya_mapping_revision'];
  function randomId(crypto) {
    if(typeof crypto?.randomUUID==='function')return crypto.randomUUID();
    if(typeof crypto?.getRandomValues!=='function')throw Error('CRYPTO_UNAVAILABLE');
    const bytes=crypto.getRandomValues(new Uint8Array(16));
    bytes[6]=(bytes[6]&15)|64;bytes[8]=(bytes[8]&63)|128;
    return Array.from(bytes,b=>b.toString(16).padStart(2,'0')).join('');
  }
  function create({fetch:readFetch,getOrigin,getRoutesRoot,crypto,timeoutMs=5000}={}) {
    async function read() {
      let timer;
      const fail=reason=>({status:'BLOCKED',reason,ordinaryCartUsable:true});
      try {
        if(typeof readFetch!=='function'||!crypto?.subtle||!Number.isSafeInteger(timeoutMs)||timeoutMs<1||timeoutMs>30000)return fail('IDENTITY_UNAVAILABLE');
        const supplied=getOrigin?.();
        if(typeof supplied!=='string'||!supplied.trim())return fail('ORIGIN_UNAVAILABLE');
        const origin=new URL(supplied).origin;
        if(!/^https?:\/\//.test(origin))return fail('ORIGIN_UNAVAILABLE');
        const routesRoot=getRoutesRoot?.();
        if(typeof routesRoot!=='string'||!/^\/(?:[a-zA-Z0-9_-]+\/)*$/.test(routesRoot))return fail('LOCALE_ROUTE_UNAVAILABLE');
        const controller=new AbortController();
        const operation=(async()=>{
          const response=await readFetch(new URL(routesRoot+'cart.js',origin).href,{method:'GET',credentials:'same-origin',cache:'no-store',redirect:'error',signal:controller.signal,headers:{Accept:'application/json'}});
          if(response?.ok!==true)throw Error('CART_READ_FAILED');
          const raw=await response.json();
          if(typeof raw?.token!=='string'||!raw.token.trim())return fail('CART_TOKEN_UNAVAILABLE');
          // Token is opaque. Do not split a secret suffix, normalize its contents, store or return it.
          const binding=await Ownership.bindCart({cartToken:raw.token,origin,subtle:crypto.subtle});
          if(!/^[a-f0-9]{64}$/.test(binding)||!Array.isArray(raw.items)||!Number.isSafeInteger(raw.item_count)||raw.item_count<0)throw Error('CART_SHAPE_INVALID');
          const items=raw.items.map(line=>{
            if(!line||typeof line.key!=='string'||!line.key||!Number.isSafeInteger(line.quantity)||line.quantity<1||
                !/^[1-9]\d*$/.test(String(line.product_id))||!/^[1-9]\d*$/.test(String(line.variant_id)))throw Error('CART_LINE_INVALID');
            const properties={};
            for(const key of privateKeys)if(Object.hasOwn(line.properties||{},key)) {
              const value=line.properties[key];
              if(typeof value!=='string'||!/^[a-zA-Z0-9_-]{1,80}$/.test(value))throw Error('MANAGED_METADATA_INVALID');
              properties[key]=value;
            }
            // Never return titles, custom property values, attributes, notes, addresses or customer data.
            const keys=Object.keys(line.properties||{}), unsupported=keys.some(k=>!privateKeys.includes(k));
            return {key:line.key,sku:typeof line.sku==='string'?line.sku:null,product_id:String(line.product_id),variant_id:String(line.variant_id),quantity:line.quantity,properties,
              managedLooking:keys.some(k=>k.startsWith('_nikuya_')),
              ...(unsupported?{personalization:true}:{}),
              ...(line.selling_plan_allocation!=null?{selling_plan_allocation:{unsupported:true}}:{}),
              ...(line.parent_relationship!=null?{parent_relationship:{unsupported:true}}:{}),
              ...(line.item_components!=null&&(!Array.isArray(line.item_components)||line.item_components.length)?{item_components:[{unsupported:true}]}:{})};
          });
          if(new Set(items.map(l=>l.key)).size!==items.length||items.reduce((n,l)=>n+l.quantity,0)!==raw.item_count)throw Error('CART_COUNT_INVALID');
          const snapshot={authoritative:true,revision:randomId(crypto),items,itemCount:raw.item_count};
          // Empty observations carry no ownership binding, even if Shopify retains the digest.
          if(raw.item_count===0)return {status:'EMPTY_UNMATERIALIZED',observedBinding:binding,origin,routesRoot,snapshot,ordinaryCartUsable:true};
          return {status:'VERIFIED_MATERIALIZED_CART',binding,origin,routesRoot,snapshot:{...snapshot,binding},ordinaryCartUsable:true};
        })();
        return await Promise.race([operation,new Promise(resolve=>{timer=setTimeout(()=>{controller.abort();resolve(fail('CART_READ_TIMEOUT'))},timeoutMs)})]);
      } catch (_) { return fail('CART_IDENTITY_UNAVAILABLE'); }
      finally {clearTimeout(timer)}
    }
    return Object.freeze({read});
  }
  return Object.freeze({create,randomId});
});
